/**
 * section-templates/programs_section.php's .program-modal scrollbar +
 * Escape-to-close. Same pure-CSS :target modal architecture as
 * .staff-modal (modules/staff.js) -- see modules/target-modal-scrollbar.js's
 * own doc comment for why this exists at all.
 */

import initTargetModalScrollbar from './target-modal-scrollbar.js';

export default function initProgramsModal() {
    initTargetModalScrollbar({
        scrollAreaSelector: '.program-modal:target .program-modal__description',
        panelSelector: '.program-modal__panel',
        targetSelector: '.program-modal',
        closedHash: 'program-modal-closed',
    });
}
